import { call, put, takeLatest } from "redux-saga/effects";
import { callAPI, handleError, handleSuccess } from "../api/api";
import axios from "axios";
import { setLoaderAction, setNotificationAction } from "../reducers/mmymSlice";

import {
  addComplaintAction,
  getAllComplaintsAction,
  getComplaintByIdAction,
  getComplaintByIdResponseAction,
  getComplaintCostsAction,
  getComplaintInProgressAction,
  getComplaintTaskAction,
  getLeadComplaintAction,
  getLeadComplaintResponseAction,
  setAddComplaintResponse,
  setAllComplaintsAction,
  setComplaintCostsResponseAction,
  setComplaintInProgressResponseAction,
  setComplaintTaskResponseAction,
  deleteComplaintTaskAction,
  setDeleteComplaintTaskResponse,
  addComplaintCostAction,
  setAddComplaintCostResponseAction,
  addComplaintInProgressAction,
  setAddComplaintInProgressResponseAction,
} from "../reducers/complaintSlice";

/**
 * This function for call the user profile
 *
 * @param {*} payload
 */

function* getAllComplaintsSaga(action: {
  type: string;
  payload: {
    page: number;
    limit: number;
    orderBy: string;
    orderIn: string;
    roleType?: string;
    search: string;
    status: string;
    leadId?: string;
  };
}): any {
  yield put(setLoaderAction(true));
  const { page, limit, orderBy, orderIn, roleType, search, status, leadId } =
    action.payload;
  try {
    const res = yield call<any>(
      callAPI,
      {},
      "get",
      `leads/complaints?status=${status}&page=${page}&limit=${limit}&orderBy=${orderBy}&orderIn=${orderIn}${leadId ? `&lead_id=${leadId}` : ""}`,
    );
    console.log("plans-", res);
    if (res?.data) {
      yield put(setAllComplaintsAction(res?.data));
    }
  } catch (error) {
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

function* getLeadComplaintSaga(action: any): any {
  yield put(setLoaderAction(true));
  const { lead_id, status } = action.payload;
  console.log("plans-try");
  try {
    const res = yield call<any>(
      callAPI,
      {},
      "get",
      `leads/complaints?lead_id=${lead_id}&status=${status}`,
    );
    console.log("plans-", res);
    if (res?.data) {
      yield put(getLeadComplaintResponseAction(res?.data));
    }
  } catch (error) {
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

function* addComplaintSaga(payload: any[]): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      payload,
      "post",
      "leads/complaints",
    );
    console.log("changePassword-", apiResponse);
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setAddComplaintResponse(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setAddComplaintResponse(false));
  }
  yield put(setLoaderAction(false));
}

function* getComplaintByIdSaga(action: any): any {
  yield put(setLoaderAction(true));
  const { complaint_id } = action.payload;
  console.log("plans-try");
  try {
    const res = yield call<any>(
      callAPI,
      {},
      "get",
      `leads/complaints/${complaint_id}`,
    );
    console.log("plans-", res);
    if (res?.data) {
      yield put(getComplaintByIdResponseAction(res?.data));
    }
  } catch (error) {
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

// task
function* getComplaintTaskSaga(action: any): any {
  yield put(setLoaderAction(true));
  const { complaint_id, start, end } = action.payload;
  console.log("plans-try");
  try {
    const res = yield call<any>(
      callAPI,
      {},
      "get",
      `client/tasks?complaint_id=${complaint_id}`,
    );
    console.log("plans-", res);
    if (res?.data) {
      yield put(setComplaintTaskResponseAction(res?.data));
    }
  } catch (error) {
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

// costs
function* getComplaintCostsSaga(action: any): any {
  yield put(setLoaderAction(true));
  const { complaint_id, start, end } = action.payload;
  console.log("plans-try");
  try {
    const res = yield call<any>(
      callAPI,
      {},
      "get",
      `leads/complaint-costs?complaint_id=${complaint_id}`,
    );
    console.log("plans-", res);
    if (res?.data) {
      yield put(setComplaintCostsResponseAction(res?.data));
    }
  } catch (error) {
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

// in progress
function* getComplaintInProgressSaga(action: any): any {
  yield put(setLoaderAction(true));
  const { complaint_id } = action.payload;
  console.log("plans-try");
  try {
    const res = yield call<any>(
      callAPI,
      {},
      "get",
      `leads/complaint-progress?complaint_id=${complaint_id}`,
    );
    console.log("plans-", res);
    if (res?.data) {
      yield put(setComplaintInProgressResponseAction(res?.data));
    }
  } catch (error) {
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

// delete task
function* deleteComplaintTaskSaga(action: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  const { task_id, complaint_id } = action.payload;
  try {
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "delete",
      `client/tasks/${task_id}`,
    );
    console.log("deleteComplaintTask-", apiResponse);
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setDeleteComplaintTaskResponse(true));
      // Refresh the task list
      // const startDate = new Date().toISOString().split('T')[0];
      // const endDate = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0];
      // yield put(getComplaintTaskAction({ complaint_id, start: startDate, end: endDate }));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setDeleteComplaintTaskResponse(false));
  }
  yield put(setLoaderAction(false));
}

//
function* addComplaintCostSaga(action: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  console.log("addComplaintCostSaga-action-", action);
  const { ...costDetails } = action.payload;
  try {
    const apiResponse = yield call<any>(
      callAPI,
      { payload: costDetails },
      "post",
      `leads/complaint-costs`,
    );
    console.log("addComplaintCostSaga-", apiResponse);
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setAddComplaintCostResponseAction(true));
      // Refresh the costs list
      // yield put(getComplaintCostsAction({ complaint_id }));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setAddComplaintCostResponseAction(false));
  }
  yield put(setLoaderAction(false));
}

// add complaint in progress
function* addComplaintInProgressSaga(action: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  console.log("addComplaintInProgressSaga-action-", action);
  const { ...progressDetails } = action.payload;
  try {
    const apiResponse = yield call<any>(
      callAPI,
      { payload: progressDetails },
      "post",
      `leads/complaint-progress`,
    );
    console.log("addComplaintInProgressSaga-", apiResponse);
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setAddComplaintInProgressResponseAction(true));
      // Refresh the in progress list
      // yield put(getComplaintInProgressAction({ complaint_id }));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setAddComplaintInProgressResponseAction(false));
  }
  yield put(setLoaderAction(false));
}

export function* watchComplaint() {
  yield takeLatest<any>(getAllComplaintsAction, getAllComplaintsSaga);
  yield takeLatest<any>(addComplaintAction, addComplaintSaga);
  yield takeLatest<any>(getLeadComplaintAction, getLeadComplaintSaga);
  yield takeLatest<any>(getComplaintByIdAction, getComplaintByIdSaga);
  yield takeLatest<any>(getComplaintTaskAction, getComplaintTaskSaga);
  yield takeLatest<any>(getComplaintCostsAction, getComplaintCostsSaga);
  yield takeLatest<any>(
    getComplaintInProgressAction,
    getComplaintInProgressSaga,
  );
  yield takeLatest<any>(deleteComplaintTaskAction, deleteComplaintTaskSaga);
  yield takeLatest<any>(addComplaintCostAction, addComplaintCostSaga);
  yield takeLatest<any>(addComplaintInProgressAction, addComplaintInProgressSaga);
}
